import script from "./ProjectCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectCard.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectCard.vue?vue&type=style&index=0&id=479a4da0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-479a4da0"]])

export default __exports__